<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <polygon class="filled" points="17.22 6.715 15.099 8.836 20.764 14.5 5.494 14.5 5.494 17.5 20.763 17.5 15.099 23.164 17.22 25.285 26.506 16 17.22 6.715" fill="#035ce0"/>
    <rect width="32" height="32" fill="none"/>
  </g>
</svg>
